module.exports = "/dist/1dd2b53f1567a29e0505de9b27c4352c.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-700italic.woff2
// module id = 135
// module chunks = 0